module.exports = __webpack_public_path__ + "static/media/ants_cover_w_binder.90d393ec.jpeg";